import { useEffect, useState } from 'react'
import GetUrls from 'ts/enums/Url'
import { Class } from 'ts/types'
import useModalStore from 'store/modal'
import { CheckBoxToggle, Input } from 'components/ui'
import useModalForm from 'hooks/useModalForm'

const ClassAddPage = () => {
  const Url = GetUrls();
  const params = useModalStore((state) => state.params) as Class
  const { ModalForm, form } = useModalForm()
  const { setValue, register } = form
  const [isActive, setIsActive] = useState<boolean>(true);

  useEffect(() => {
    if (params) {
      setValue('classId', params.classId)
      setIsActive(params.flActive);
    }
  }, [params, setValue])
  
  const handleToggleActive = (isChecked: boolean) => {
    setIsActive(isChecked);
  }
  
  return (
    <ModalForm 
      config={{ url: Url.postClass, method: params ? 'PUT' : 'POST' }}
      // altApiCall={{ url: params ? Url.updateClassAlt : Url.postClassAlt, method: params ? "PUT" : "POST" }}
      title={`${ params ? 'Edit ' : 'Create ' }Class` }
      description='Create or edit a class'
    >
      <div className='flex gap-8'> 
        <CheckBoxToggle 
          label="Active" 
          defaultChecked={isActive} 
          onToggle={handleToggleActive}
        />
        <Input
            label="Active" 
            className='hidden'
            {...register("flActive", { value : isActive ? 1 : 0 })}
        />
        {params ? (
          <Input defaultValue={ params.classId } label="ID" disabled className='hidden' />
        ) : null}
      </div>
      <Input
        defaultValue={params?.name || ''}
        label="Class Name"
        {...register('name', { required: true })}
      />
    </ModalForm>
  )
}

export default ClassAddPage
